import { Component, Input, ViewChild, OnInit, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

/**
 * ラベル持ちラジオボタンクラス
 *
 * @export RadioLabelComponent
 * @class RadioLabelComponent
 */
@Component({
  selector: 'app-radio-label',
  templateUrl: 'radio-label.component.html',
  styleUrls: ['radio-label.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RadioLabelComponent,
      multi: true,
    },
  ]
})
export class RadioLabelComponent implements OnInit, ControlValueAccessor {

  @ViewChild('radio', { static: true }) public radio: ElementRef;

  @Input() public subid: string = null;
  /** パネル幅 */
  @Input() width: number = <number>0;
  /** パネル高さ */
  @Input() height: number = <number>0;
  /** 強制活性モードフラグ */
  @Input() forcedEnabledMode: string = null;
  /** ラベル */
  @Input() label: string = null;
  /** ID */
  @Input() id: string = null;
  /** 名前 */
  @Input() name: string = null;
  /** 値 */
  @Input() value: string = null;
  /** タブインデックス */
  @Input() tabindex: number = null;
  /** 可視フラグ デフォルトはtrue*/
  @Input() visible: boolean = <boolean>true;
  /** 活性フラグ  デフォルトはtrue*/
  @Input() public disabled: boolean = <boolean>false;
  /** フォントサイズ */
  @Input() fontSize: number = null;
  /** 選択 */
  @Input() checked: boolean = <boolean>false;
  /** autofocus */
  @Input() autofocus: boolean = <boolean>false;

  /**
   * Creates an instance of RadioLabelComponent.
   * @memberof RadioLabelComponent
   */
  constructor(
    public elementRef: ElementRef,
  ) { }

  onTouchedCallback: () => {};
  propagateChange = (_: any) => { };

  writeValue(value: string) {
    if (value === this.value) {
      this.radio.nativeElement.checked = true;
    } else {
      this.radio.nativeElement.checked = false;
    }
  }

  onChange(value: string) { }
  onTouched() { }
  registerOnChange(fn: any) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  /**
   * 初期処理
   *
   * @memberof RadioLabelComponent
   */
  ngOnInit() {
    this.radio.nativeElement.setAttribute('id', this.subid + '_sub');
    this.radio.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * ラジオ選択判定
   */
  public selectedValue() {
    return this.radio.nativeElement.checked;
  }

  /**
   * setFocusOverride
   */
  public setFocus(): void {
    this.radio.nativeElement.focus();
  }

}
